import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionPeoplePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionPeople.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionPeople.button1'),
          value: 'just_me',
        },
        {
          text: t('pages.onboarding.questionPeople.button2'),
          value: '2_people',
        },
        {
          text: t('pages.onboarding.questionPeople.button3'),
          value: '3_4_people',
        },
        {
          text: t('pages.onboarding.questionPeople.button4'),
          value: '5_plus_people',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
